module.exports = __webpack_public_path__ + "static/lesson_10-196c573cea87f1021dd8fdf54c0a7c09.png";